module.exports = __webpack_public_path__ + "img/2-2.e4fbd6e0.png";